export interface GaTaggingInfo {
  applicationExpiryDate: string;
  applicationExpiryCountdown: string;
  selectedPaymentTerm: string;
  status: string;
  maxInstallmentAmount: string;
  offerMaxInterestRate: string;
  productType: string;
}
